"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Print_exports = {};
__export(Print_exports, {
  default: () => Print_default
});
module.exports = __toCommonJS(Print_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.5 9.25391C15.6823 9.25391 15.8385 9.1888 15.9688 9.05859C16.099 8.92839 16.1641 8.77214 16.1641 8.58984C16.1641 8.40755 16.099 8.2513 15.9688 8.12109C15.8385 7.99089 15.6823 7.92578 15.5 7.92578C15.3177 7.92578 15.1615 7.99089 15.0312 8.12109C14.901 8.2513 14.8359 8.40755 14.8359 8.58984C14.8359 8.77214 14.901 8.92839 15.0312 9.05859C15.1615 9.1888 15.3177 9.25391 15.5 9.25391ZM7.33594 3.70703C7.15365 3.70703 6.9974 3.77214 6.86719 3.90234C6.73698 4.03255 6.67188 4.1888 6.67188 4.37109V6.20703H5.32422C4.73828 6.20703 4.23047 6.42188 3.80078 6.85156C3.38411 7.26823 3.17578 7.77604 3.17578 8.375V12.2812C3.17578 12.8802 3.38411 13.3945 3.80078 13.8242C4.23047 14.2409 4.73828 14.4492 5.32422 14.4492H6.67188V16.168C6.67188 16.3503 6.73698 16.5065 6.86719 16.6367C6.9974 16.7669 7.15365 16.832 7.33594 16.832H13.6641C13.8464 16.832 14.0026 16.7669 14.1328 16.6367C14.263 16.5065 14.3281 16.3503 14.3281 16.168V14.4492H15.832C16.431 14.4492 16.9388 14.2409 17.3555 13.8242C17.7852 13.3945 18 12.8802 18 12.2812V8.375C18 7.77604 17.7852 7.26823 17.3555 6.85156C16.9388 6.42188 16.431 6.20703 15.832 6.20703H14.3281V4.37109C14.3281 4.1888 14.263 4.03255 14.1328 3.90234C14.0026 3.77214 13.8464 3.70703 13.6641 3.70703H7.33594ZM6.67188 10.9141V13.4531H5.32422C5.01172 13.4531 4.73828 13.3424 4.50391 13.1211C4.28255 12.8867 4.17188 12.6068 4.17188 12.2812V8.375C4.17188 8.04948 4.28255 7.77604 4.50391 7.55469C4.73828 7.32031 5.01172 7.20312 5.32422 7.20312H15.832C16.1576 7.20312 16.431 7.32031 16.6523 7.55469C16.8867 7.77604 17.0039 8.04948 17.0039 8.375V12.2812C17.0039 12.6068 16.8867 12.8867 16.6523 13.1211C16.431 13.3424 16.1576 13.4531 15.832 13.4531H14.3281V10.9141C14.3281 10.7318 14.263 10.5755 14.1328 10.4453C14.0026 10.3151 13.8464 10.25 13.6641 10.25H7.33594C7.15365 10.25 6.9974 10.3151 6.86719 10.4453C6.73698 10.5755 6.67188 10.7318 6.67188 10.9141ZM13.332 6.20703H7.66797V4.70312H13.332V6.20703ZM7.66797 11.2461H13.332V15.8359H7.66797V11.2461Z",
      fill: "currentColor"
    }
  )
);
const SvgPrint = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Print_default = SvgPrint;
